import type { FaireProductEntity } from "../../entity_types/product";

export const p_fydxdns3ub: FaireProductEntity = {
  token: "p_fydxdns3ub",
  type: "product",
  name: "Mixed Texture Knit Button V Neck Sweater Cardigan (S-XL)",
  brandToken: "b_fpqcwkn7v8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0b5d3c618645a14ddfa9085509e780192f251180d81d0dca6fab2ed9da9c709d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/343ce1a5daef5c91f293912c6ddfe1b82153c3203bffc6b0e4e160f01c24e41c.png",
    "https://cdn.faire.com/fastly/df229691e8dd760e0ed3d000ae6579cc251cd2d1a8f582278c03bd60dafcc61e.png",
    "https://cdn.faire.com/fastly/551484417ac910286a9ca58927faeaa9187f7c401da4a9d418a2530c356c625c.png",
    "https://cdn.faire.com/fastly/a821e3682ecf5224b4d24afbbaa9257dd47301e28c185343de4512128c9269b9.png",
    "https://cdn.faire.com/fastly/63da67689e725dba5cb40e18614a1afb5b551e19f89aaaf04302405716b5c068.jpeg",
    "https://cdn.faire.com/fastly/025beb1c17fc3450d272afe971b710c216a1974ce787ccf5920cdd180e71535c.jpeg",
    "https://cdn.faire.com/fastly/5907ece2c9a1c894cc000f9bf21d3ef1199f777d66a599a466aea764410bcec7.jpeg",
    "https://cdn.faire.com/fastly/6e15196e0c7c45b3f15b652bd04a351061aea0ceb107f6177e586e7b2130546c.jpeg",
    "https://cdn.faire.com/fastly/5fbf7159dc90bf0dd5af3155bc8df0a85d94468df98f00b1c828113dee2a61f4.jpeg",
    "https://cdn.faire.com/fastly/2ac3d54dcce4b27de8ccaee30f6c9848c850bdc3a68974952c6d667127cc24d3.jpeg",
    "https://cdn.faire.com/fastly/0cdc25ac4702c37b914f206fb9c791d5a66ed0355e8f3a678e020477d4fc8571.jpeg",
    "https://cdn.faire.com/fastly/97c45123fbc40a6813276801b006fc36f22824007737bbdcffab67ac6a348c92.jpeg",
    "https://cdn.faire.com/fastly/62d262d8d750fd95073430037fa05669a7325f504d30a139c3f6a518c80c563d.jpeg",
  ],
  priceDollars: 32.64,
  description:
    "🎀Material: 52%Viscose+26%Polyester+22%Polyamide\n😍Why You’ll Love It?\n\n1. Mixed texture knit design adds visual interest and a cozy feel.  \n2. Button-up V-neck style allows for versatile layering options.  \n3. Soft, stretchy fabric ensures all-day comfort.  \n4. Perfect for pairing with jeans, skirts, or layering over dresses.\n\n💌Note: Our products currently come with size and care labels only. If you need branded labels, please contact us for custom options!\nWestern/Cardigan/Sweater/Christmas/Holiday/Fall/Tops\n/Cozy/Holiday Sweaters\n",
  tags: [],
  msrpDollars: 65.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:39.848Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
